import { Outlet, useNavigate } from "react-router-dom";
import './../../assets/styles/fintech.css'
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import { useEffect, useState } from "react";
import TransportAgentSettings from "../../components/transport-agent/Settings";
import TransportAgentHeader from "../../components/transport-agent/Header";
import TransportAgentSidebar from "../../components/transport-agent/Sidebar";
import TransportAgentFooter from "../../components/transport-agent/Footer";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import storePersist from "../../redux/storePersist";
import ThemeProvider from "../../hooks/themeProvider";


const TransportAgentLayout = () => {
	let navigate = useNavigate()
	const dispatch = useAppDispatch()
	const [color, setColor] = useState('universal')
	const handleSettigns = () => {
		dispatch(settings.set({ visible: !visible }))
	}
	const userProfileData = storePersist?.get("userProfile")?.current;
	const { height, width } = useWindowDimensions();
	const result = useSelector(selectCurrent)
	const { header, footer, visible, sidebar,theme } = result
	
	useEffect(() => {
		dispatch(settings.set({
			theme: 'universal',
		}))
	}, [])
	
	return (
		<>
			<ThemeProvider>

				{width && width < 720 ?
					<>

						<TransportAgentHeader />
						<div className='h-full pb-20'>
							<Outlet />
						</div>
						<TransportAgentFooter />


					</>
					:
					<div className="leading-normal tracking-normal" id="main-body">
						<div className="flex flex-col w-full sm:hide max-h-screen h-screen bg-slate-200">
							{visible ? <TransportAgentSettings /> : <></>}
							<TransportAgentHeader />
							<div className="w-full flex flex-row bg-primary">
								<TransportAgentSidebar />

								<div className={`${sidebar ? `ml-64` : `ml-24 z-0 `} w-full overflow-auto mt-20 bg-slate-200 dark:bg-slate-300`}>

									<Outlet />

								</div>
								<div className="fixed bottom-0 z-[1000] w-full bg-slate-50">
									{footer ? <TransportAgentFooter /> : ""}
								</div>
							</div>
						</div>
					</div>}
			</ThemeProvider>
		</>
	)
}
export default TransportAgentLayout;